import { connect } from 'react-redux'
import UniversalMenuConfigModal from '@components/groupOrders/UniversalMenuConfigModal'
import coordinators from '@coordinators'
import presenters from '@presenters'
import services from '@services'
import { HandleError } from '@coordinators/composed'

const mapDispatchToProps = () => {
  const { RestService, ChefService, UIService } = services
  const {
    AddItemToBlacklist,
    AddVendorToBlacklist,
    LoadChefs,
    SearchMenuItems,
    UpdateItemBlacklistEntry,
    UpdateVendorBlacklistEntry,
  } = coordinators
  const { pResponseChefs, pResponseIndexMenuItems } = presenters.Api
  const loadChefs = LoadChefs({ ChefService, RestService, pResponseChefs })

  // Item
  const addItemToBlacklist = AddItemToBlacklist({
    RestService,
    HandleError,
  })
  const updateItemBlacklistEntry = UpdateItemBlacklistEntry({
    RestService,
    HandleError,
  })

  // Vendor
  const addVendorToBlacklist = AddVendorToBlacklist({
    RestService,
    HandleError,
  })
  const updateVendorBlacklistEntry = UpdateVendorBlacklistEntry({
    RestService,
    HandleError,
  })

  const loadMenuItems = SearchMenuItems({
    RestService,
    pResponseMenuItemsSearch: pResponseIndexMenuItems,
  })

  const { displayInfoModal, dismissInfoModal } = UIService.InfoModal

  return {
    addItemToBlacklist,
    addVendorToBlacklist,
    dismissInfoModal,
    showCustomModal: displayInfoModal,
    loadChefs,
    loadMenuItems,
    updateItemBlacklistEntry,
    updateVendorBlacklistEntry,
  }
}

export default connect(undefined, mapDispatchToProps)(UniversalMenuConfigModal)
